import cn from 'classnames';
import React, { useRef } from 'react';
import Modal from 'react-modal';
import { Close } from '@shared/assets';
import useOutsideClick from 'library/hooks/common/useOutsideClick';
import type { Table as TableType } from 'library/models/shop';
import * as st from './Table.module.scss';

type Props = {
  tables: TableType[];
};

const Table: React.FC<Props> = ({ tables }) => {
  const [showList, setShowList] = React.useState<boolean>(false);
  const buttonRef = React.useRef(null);
  const listRef = React.useRef(null);

  const SizeTable = (): number[] => {
    const width = window.innerWidth >= 1180 ? 1140 : window.innerWidth - 40;
    const height = window.innerHeight - 200;
    return [width, height];
  };

  const onOutsideClick = () => {
    setShowList(false);
  };

  const onListButtonClick = () => {
    setShowList((showList) => !showList);
  };

  useOutsideClick([buttonRef, listRef], onOutsideClick);

  return (
    <div className={st.tables}>
      <button className={st.button} ref={buttonRef} onClick={onListButtonClick}>
        Таблица размеров
      </button>
      <Modal className={st.modal} overlayClassName={st.overlay} isOpen={showList}>
        <div
          className={cn(st.main, showList && st.active)}
          ref={listRef}
          onClick={onListButtonClick}
        >
          {tables.map((table) => (
            <div
              style={{
                maxWidth: `${SizeTable()[0]}px`,
                width: `max-content`,
              }}
              className={st.table}
              key={table.id}
            >
              <button className={st.close}>
                <Close />
              </button>
              <h4 className={st.table__title}>{table.title}</h4>
              <table cellSpacing={0} cellPadding={0} className={st.table__table}>
                <tbody
                  style={{
                    maxWidth: `${SizeTable()[0]}px`,
                    width: `max-content`,
                    maxHeight: `${SizeTable()[1]}px`,
                    height: `max-content`,
                  }}
                >
                  {table.table.map((row, index) => (
                    <tr key={index} style={{ fontFamily: 'Roboto' }}>
                      {row.map((cell, index) => (
                        <td key={index}>{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </Modal>
    </div>
  );
};

export default Table;
